export const detailsData = {
}